import { LoginStore } from "../store/LoginStore"

class PermissionUtil {


    static PERMISSION_GERENCIAR_PAGAMENTO_SERVICO_LISTAGEM = "projetos_gerenciar_pagamento_servico"
    static PERMISSION_ACAO_CONFIRMAR_VISITA_TECNICA = "projetos_confirmar_visita_tecnica"
    static PERMISSION_ACAO_REATIVAR = "projetos_reativar"
    static PERMISSION_ACAO_FINALIZAR = "projetos_finalizar"
    static PERMISSION_ACAO_VISUALIZAR_PROPOSTA = "projetos_visualizar_proposta"
    static PERMISSION_ACAO_VISUALIZAR_PROPOSTA_SIMPLIFICADA = "projetos_visualizar_proposta_simplificada"
    static PERMISSION_ACAO_VISUALIZAR_PROPOSTA_DISCRIMINAR_VALORES = "projetos_visualizar_proposta_discriminar_valores"
    static PERMISSION_ACAO_EDITAR_SERVICO = "projetos_editar_servico"
    static PERMISSION_ACAO_SOLICITAR_REVISAO = "projetos_solicitar_revisao"
    static PERMISSION_ACAO_APLICAR_DESCONTO = "projetos_aplicar_desconto"
    static PERMISSION_ACAO_DOCUMENTO_SERVICO = "projetos_documento_servico"
    static PERMISSION_ACAO_ENVIAR_NOTA_FISCAL_VENDA = "projetos_enviar_nota_fiscal_venda"
    static PERMISSION_ACAO_CANCELAR = "projetos_cancelar"
    static PERMISSION_ACAO_ENVIAR_PAGAMENTO = "projetos_enviar_pagamento"
    static PERMISSION_ACAO_REPROCESSAR_PAGAMENTO = "projetos_reprocessar_pagamento"
    static PERMISSION_ACAO_ATUALIZAR_ENTREGA = "projetos_atualizar_entrega"
    static PERMISSION_ACAO_EDITAR_PROJETO = "projetos_editar_projeto"
    static PERMISSION_ACAO_DETALHES_PROJETO = "projetos_detalhes_projeto"
    static PERMISSION_ACAO_VISUALIZAR_HISTORICO = "projetos_visualizar_historico"
    static PERMISSION_ACAO_APLICAR_DESCONTO_REVENDA = "projetos_aplicar_desconto_revenda"
    static PERMISSION_ACAO_APLICAR_DESCONTO_DISTRIBUIDOR = "projetos_aplicar_desconto_distribuidor"
    static PERMISSION_ACAO_APLICAR_DESCONTO_INTELBRAS = "projetos_aplicar_desconto_intelbras"
    static PERMISSION_ACAO_APLICAR_DESCONTO_HISTORICO = "projetos_aplicar_desconto_historico"
    static PERMISSION_POPUPS_LISTAGEM = "popups_listagem"
    static PERMISSION_TELEFONES_LISTAGEM = "telefones_listagem"
    static PERMISSION_PROJETO_PERSONALIZADO = "projetos_menu_projeto_personalizado"
    static PERMISSION_PROJETO_DIMENSIONADO = "projetos_menu_projeto_dimensionado"
    static PERMISSION_PROJETO_ESPECIAL = "projetos_menu_projeto_especial"
    static PERMISSION_VENDEDORES_LISTAGEM = "vendedores_listagem"

    static PERMISSION_PROJETO_ENGENHARIA_DOWNLOAD_ANEXO = "projetos_verticais_engenharia_download_anexos"
    static PERMISSION_PROJETO_ENGENHARIA_SOLICITAR_PAUSA = "projetos_verticais_engenharia_solicitar_pausa"
    static PERMISSION_PROJETO_ENGENHARIA_CANCELAR = "projetos_verticais_engenharia_cancelar"
    static PERMISSION_PROJETO_ENGENHARIA_EDITAR = "projetos_verticais_engenharia_manutencao"
    static PERMISSION_PROJETO_ENGENHARIA_NOVO = "projetos_engenharia_novo"
    static PERMISSION_PROJETO_ENGENHARIA_VISUALIZAR = "projetos_engenharia_visualizar"
    static PERMISSION_PROJETO_ENGENHARIA_LISTAGEM = "projetos_verticais_engenharia_listagem"
    static PERMISSION_PROJETO_FILTRAR_REVENDA_SEM_DISTRIBUIDOR = "projetos_filtrar_revenda_sem_distribuidor"
    static PERMISSION_LOJA_ONGRID = "lojas_loja_ongrid"
    static PERMISSION_LOJA_OFFGRID = "lojas_loja_offgrid"
    static PERMISSION_LOJA_AVULSO = "lojas_loja_avulso"
    static PERMISSION_PROJETO_DISTRIBUIDOR_LISTAGEM = "distribuidor_listagem"
    static PERMISSION_PROJETO_DISTRIBUIDOR_MANUTENCAO = "distribuidor_manutencao"
    static PERMISSION_PROJETO_PROPOSTA_COMERCIAL = "proposta_comercial_listagem"
    static PERMISSION_PROJETO_EMAIL_LISTAGEM = "email_notificacao_listagem"
    static PERMISSION_PROJETO_EMAIL_MANUTENCAO = "email_notificacao_manutencao"
    static PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE = "projetos_visualizar_codigo_componente"
    static PERMISSION_PROJETO_DETALHE_VISUALIZAR_FATOR = "projetos_visualizar_fator_componente"
    static PERMISSION_PROJETO_DETALHE_VISUALIZAR_VALORES = "projetos_visualizar_valores_componente"
    static PERMISSION_PROJETOS_VERTICAIS_REVISAO = "projetos_verticais_revisao"
    static PERMISSION_PROJETOS_VERTICAIS_MANUTENCAO = "projetos_verticais_manutencao"
    static PERMISSION_PROJETOS_VERTICAIS_LISTAGEM = "projetos_verticais_listagem"
    static PERMISSION_ACAO_EDICAO_AVANCADA = "projetos_edicao_avancada_listagem"
    static PERMISSION_PROJETO_CONTAS_PERMITE_TROCA_LOGO = "proposta_comercial_uploads_manutencao"
    static PROJETOS_DOCUMENTOS_SERVICO_UPLOADS = "projetos_documentos_servico_uploads_manutencao"
    static PERMISSION_REENVIAR_NOTA_FISCAL = "projetos_reenviar_nota_fiscal"
    static PERMISSION_FINALIZAR_PROJETO_MANUAL = "projetos_finalizar_projeto_renovigi"
    static PERMISSION_PROJETOS_EDITAR_ESPECIAL_SERVICO = "projetos_edicao_especial_valor_servico"
    static PERMISSION_ACAO_CLONAR_PROJETO_ONGRID = "projetos_clonar_projeto"
    static PERMISSION_ACAO_CLONAR_PROJETO_OFFGRID = "projetos_clonar_projeto_offgrid"
    static PERMISSION_ATUALIZAR_MENSAGEM_WHATSAPP = "proposta_comercial_whatsapp_mensagem_manutencao"
    static PERMISSION_ENVIAR_MENSAGEM_WHATSAPP = "projetos_enviar_whatsapp_mensagem"
    static PERMISSION_ACAO_CLONAR_PROJETO_HIBRIDO = "projetos_clonar_projeto_hibrido"
    
    static PERMISSION_PROJETO_BIBLIOTECAS_ESTATISTICAS_MANUTENCAO = "bibliotecas_estatisticas_manutencao"

    static PERMISSION_DASHBOARD_ACESSO = "dashboard_acesso"
    static PROJETOS_LISTAGEM = "projetos_listagem"
    static PROJETOS_MANUTENCAO = 'projetos*_manutencao'
    static PERMISSION_PROJETOS_LISTAGEM = "projetos*_listagem"
    static PERMISSION_HISTORICO_PROJETOS = "projetos_visualizar_historico_projetos"
    static PERMISSION_HISTORICO_PEDIDOS = "projetos_visualizar_historico_pedidos"
    static PERMISSION_HISTORICO_NOTAS_FISCAIS = "projetos_visualizar_historico_notas_fiscais"
    static PERMISSION_HISTORICO_DESCONTOS = "projetos_visualizar_historico_descontos"
    static PERMISSION_HISTORICO_ANTIGO = "projetos_visualizar_historico_antigo";
    static PERMISSION_BIBLIOTECAS_MENU = "biblioteca_listagem";
    static PERMISSION_COMPONENTES_MENU = "componentes_listagem";
    static PERMISSION_COMPONENTES_MPPT = "modulos_inversores_listagem";
    static PERMISSION_LISTAGEM_COLABORADORES = "colaboradores_listagem";
    static PERMISSION_CRIAR_COLABORADOR = "colaboradores_manutencao";
    static PERMISSION_ATUALIZAR_COLABORADOR = "colaboradores_atualizar";
    static PERMISSION_INATIVAR_COLABORADOR = "colaboradores_inativar";
    static PERMISSION_PROJETOS_VISUALIZAR_FILIAIS = "projetos_visualizar_filiais";
    static PERMISSION_PROJETOS_EXIBIR_DADOS_GERACAO_PROPOSTA = "projetos_exibir_dados_geracao_proposta";
    static PERMISSION_PROJETOS_REENVIAR_EMAIL_PAGAMENTO = "projetos_reenviar_email_pagamento";
    static PERMISSION_PROJETOS_COPIAR_LINK_PAGAMENTO = "projetos_copiar_link_pagamento";
    static PERMISSION_CODIGO_SERVICO_MANUTENCAO = "codigo_servico_manutencao";

    static PERMISSION_PROJETO_DIMENSIONADO_OFFGRID = "projetos_menu_projeto_dimensionado_offgrid"
    static PERMISSION_PROJETO_PERSONALIZADO_OFFGRID = "projetos_menu_projeto_personalizado_offgrid"
    static PERMISSION_PROJETO_DIMENSIONADO_HIBRIDO = "projetos_menu_projeto_hibrido"
    static PERMISSION_PROJETO_PERSONALIZADO_HIBRIDO = "projetos_menu_projeto_personalizado_hibrido"

    static can(permission: string, permissionList: string[]): boolean {

        if (permissionList.length) {

            // Caso seja administrador
            if (permissionList[0] === "*") {
                return true;
            }
    
            return permissionList.includes(permission);
        } 

        return false;
    }

    static getPermissions(): string[] {
        return LoginStore.getPermission() || []
    }

    static isAdministrador(permissionList: string[]): boolean {
        if (permissionList.length) {

            // Caso seja administrador
            if (permissionList[0] === "*") {
                return true;
            }
        } 

        return false;
    }

}


export { PermissionUtil }
